export default __webpack_public_path__ + "assets/aee62eb6f11e62e6ba4a1c4515342936.svg";